import { ofType } from "redux-observable";
import { filter, mapTo } from "rxjs/operators";
import { IdTabs } from "../../../constants/IdTabs";
import { selectLastModalId } from "../../../selectors/selectModalTabId";
import { TypeActionModal } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionGetCoopEventNotices } from "../actionCoop";
export var epicSelectNoticesTab = function (action$, state$) {
    return action$.pipe(ofType(TypeActionModal.TabSelect), filter(function (action) {
        return action.tabId === IdTabs.NoticesTab &&
            selectLastModalId(state$.value) === IdModal.Cooperative;
    }), mapTo(actionGetCoopEventNotices()));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicSelectNoticesTab.ts
// module id = 1826
// module chunks = 3